import { cn } from '@lair-finance/util'
import { useDisconnect } from '@lair-finance/wagmi'
import { AssetIcon } from '@/shared/ui/Asset'
import { Button } from '@lair-finance/uikit'

export const DisconnectButton = ({ className }: { className?: string }) => {
  const { disconnect } = useDisconnect()

  return (
    <Button size={'md'} variant={'Secondary'} className={cn('text-palette-red group', className)} onClick={() => disconnect()}>
      <AssetIcon filename={'disconnect.png'} size={24} className={'group-hover:hidden'} />
      <AssetIcon filename={'disconnect-black.png'} size={24} className={'hidden group-hover:inline-block'} />
      <span className={'ml-3'}>Disconnect</span>
    </Button>
  )
}
